export function Logo({ size = "default", className = "" }) {
  const sizeMap = {
    sm: { main: "text-sm", sub: "text-[8px]", gap: "-mt-0.5" },
    default: { main: "text-lg", sub: "text-[9px]", gap: "-mt-1" },
    lg: { main: "text-2xl md:text-3xl", sub: "text-[11px] md:text-xs", gap: "-mt-1.5" },
  };
  const s = sizeMap[size] || sizeMap.default;
  return (
    <span className={`inline-flex flex-col items-end leading-none text-charcoal ${className}`}>
      <span className={`font-display tracking-[0.35em] ${s.main}`}>ORATIO</span>
      <span className={`font-display tracking-[0.4em] text-umber ${s.sub} ${s.gap}`}>REDE</span>
    </span>
  );
}

export default Logo;
